import { render, staticRenderFns } from "./MaterialItem.vue?vue&type=template&id=1c20a188&scoped=true&"
import script from "./MaterialItem.vue?vue&type=script&lang=js&"
export * from "./MaterialItem.vue?vue&type=script&lang=js&"
import style0 from "./MaterialItem.vue?vue&type=style&index=0&id=1c20a188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c20a188",
  null
  
)

export default component.exports